import React from 'react';
import Icon from '@ant-design/icons';

const chair = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="28px"
    width="28px"
    viewBox="-110 0 512 512.00109"
  >
    <path d="m9.21875 20.472656c-.492188-5.671875 1.871094-11.214844 6.308594-14.785156 4.425781-3.71875 10.035156-5.7382812 15.816406-5.6875 2.300781.0195312 4.585938.324219 6.808594.914062 35.332031 9.214844 71.613281 14.3125 108.117187 15.1875 36.503907-.875 72.78125-5.972656 108.113281-15.1875 7.890626-2.191406 16.355469-.390624 22.675782 4.820313 4.414062 3.574219 6.761718 9.113281 6.261718 14.773437-5.925781 57.363282-34.523437 125.777344-137.050781 125.777344-26.738281.921875-53.234375-5.324218-76.746093-18.09375-.128907-.0625-.230469-.164062-.355469-.226562-41.289063-24.21875-55.910157-68.390625-59.949219-107.492188zm216.429688 196.257813c-6.285157.691406-12.351563 1.300781-18.195313 1.832031l-5.824219-61.386719c6.046875-1.773437 11.96875-3.933593 17.738282-6.472656zm-134.738282-59.589844-5.824218 61.375c-5.847657-.511719-11.910157-1.121094-18.195313-1.828125l6.28125-66.066406c5.765625 2.554687 11.691406 4.730468 17.738281 6.519531zm-69.113281 351.488281c-.636719 2.015625-2.511719 3.382813-4.625 3.371094-1.445313.011719-2.816406-.636719-3.722656-1.761719-.945313-1.125-1.332031-2.613281-1.050781-4.050781l39.855468-191.03125c9.164063 3.714844 18.519532 6.945312 28.019532 9.679688zm55.898437-115.484375 5.816407-18.285156h125.476562l5.816407 18.285156zm202.425782 112.96875c.300781 1.460938-.078125 2.980469-1.035156 4.125-.90625 1.125-2.277344 1.773438-3.71875 1.761719-2.128907.011719-4.011719-1.375-4.636719-3.410156l-58.46875-183.769532c9.503906-2.738281 18.855469-5.96875 28.023437-9.683593zm10.386718-251.832031c-12.0625 22.785156-41.730468 41.371094-85.769531 53.761719-38.238281 10.761719-78.703125 10.761719-116.9375 0-44.042969-12.390625-73.710937-30.976563-85.769531-53.761719-3.128906-5.773438-2.609375-12.835938 1.324219-18.09375 4.152343-5.792969 11.285156-8.644531 18.285156-7.3125 41.199219 6.875 82.863281 10.578125 124.628906 11.082031 41.753907-.503906 83.410157-4.210937 124.597657-11.082031 7-1.332031 14.136718 1.519531 18.285156 7.3125 3.945312 5.25 4.472656 12.316406 1.355468 18.09375zm0 0" />
  </svg>
);

const tv = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    height="28px"
    width="28px"
  >
    <g>
      <g>
        <path d="M452,36H60C26.916,36,0,62.916,0,96v240c0,33.084,26.916,60,60,60h176v40H132v40h248v-40H276v-40h176    c33.084,0,60-26.916,60-60V96C512,62.916,485.084,36,452,36z M472,336c0,11.028-8.972,20-20,20H60c-11.028,0-20-8.972-20-20V96    c0-11.028,8.972-20,20-20h392c11.028,0,20,8.972,20,20V336z" />
      </g>
    </g>
  </svg>
);

const musical = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Capa_1"
    height="28"
    viewBox="0 0 512 512"
    width="28"
  >
    <path d="m437.763 0-53.626 53.623c-6.586 6.586-11.549 14.615-14.495 23.451l-10.912 32.729 43.468 43.468 32.73-10.915c8.834-2.946 16.861-7.907 23.446-14.492l53.626-53.627z" />
    <path d="m278.869 190.694c8.444 5.325 16.352 11.629 23.58 18.857 7.287 7.287 13.561 15.209 18.83 23.586l59.183-59.176-42.427-42.426z" />
    <path d="m206.99 290.01c-4.007 0-7.773 1.561-10.607 4.394-2.833 2.833-4.393 6.6-4.393 10.606s1.56 7.773 4.393 10.606 6.6 4.394 10.607 4.394 7.773-1.561 10.607-4.394c2.833-2.833 4.393-6.6 4.393-10.606s-1.56-7.773-4.393-10.606c-2.833-2.834-6.6-4.394-10.607-4.394z" />
    <path d="m132.744 230.764c-8.016 8.016-14.583 17.103-19.595 27.101-28.657 3.207-55.307 15.981-75.865 36.539-49.712 49.712-49.712 130.6 0 180.312s130.6 49.712 180.312 0c20.558-20.558 33.332-47.208 36.539-75.865 9.998-5.012 19.084-11.578 27.101-19.595 40.94-40.94 40.94-107.553 0-148.492-40.94-40.94-107.553-40.94-148.492 0zm15.91 196.221-63.64-63.64 21.213-21.213 63.64 63.64zm90.156-90.155c-8.772 8.772-20.296 13.158-31.819 13.158s-23.047-4.386-31.82-13.159c-8.499-8.499-13.18-19.799-13.18-31.819s4.681-23.32 13.18-31.819c17.546-17.545 46.096-17.547 63.64 0 8.5 8.499 13.18 19.8 13.18 31.819-.001 12.02-4.681 23.321-13.181 31.82z" />
  </svg>
);

const phone = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Capa_1"
    x="0px"
    y="0px"
    width="28px"
    height="28px"
    viewBox="0 0 37.119 37.119"
  >
    <g>
      <path d="M9.861,13.287c-0.157,0.203-0.257,0.363-0.305,0.478c-0.241,0.571-0.187,1.157,0.163,1.76   c0.353,0.604,0.639,1.036,0.863,1.302c0.348,0.45,0.779,0.866,1.29,1.252l8.442,6.651c0.564,0.408,1.079,0.71,1.536,0.904   c0.084,0.033,0.276,0.102,0.57,0.191c0.3,0.09,0.744,0.229,1.342,0.414c0.596,0.188,1.151-0.101,1.672-0.854l9.319,7.326   c-0.579,0.494-1.277,0.854-2.096,1.08c-0.819,0.228-1.867,0.371-3.142,0.438c-1.273,0.065-2.422,0.043-3.452-0.073   c-1.027-0.115-1.999-0.365-2.912-0.754c-1.94-0.82-3.896-1.769-5.865-2.835c-1.973-1.069-3.879-2.331-5.721-3.784   c-2.557-1.99-4.666-3.928-6.326-5.811c-1.662-1.879-2.85-3.645-3.565-5.293C-0.074,11.538-0.453,8.3,0.537,5.959L9.861,13.287z    M27.468,22.856c0.293-0.445,0.736-0.545,1.341-0.289c0.284,0.121,0.502,0.241,0.655,0.362l6.768,5.261   c0.618,0.432,0.911,0.76,0.886,0.987c-0.029,0.226-0.137,0.557-0.319,0.987l-1.264,1.561l-9.32-7.329L27.468,22.856z M2.759,3.107   C2.91,2.906,3.113,2.824,3.363,2.861c0.111-0.02,0.263,0.013,0.466,0.099C4.055,3.057,4.204,3.143,4.27,3.215l7.254,5.645   c0.346,0.312,0.557,0.611,0.636,0.896c0.085,0.287,0.033,0.525-0.15,0.714l-1.227,1.59L1.392,4.793L2.759,3.107z" />
    </g>
  </svg>
);

export const ChairIcon = props => <Icon component={chair} {...props} />;

export const MusicalIcon = props => <Icon component={musical} {...props} />;

export const TvIcon = props => <Icon component={tv} {...props} />;

export const PhoneIcon = props => <Icon component={phone} {...props} />;
